import React, { useEffect, useState } from "react";
import ContactUsModalView from "./ContactUsModalView";
import { getDatabase, ref, set } from "firebase/database";
import {
	getStorage,
	ref as sRef,
	uploadBytes,
	getDownloadURL,
	deleteObject,
} from "firebase/storage";
import { toast } from "react-toastify";

const AddCategoryModal = ({ isOpen, onClose, editCategory = null }) => {
	const db = getDatabase();
	const storage = getStorage();

	const [loader, setLoader] = useState(false);
	const [image, setImage] = useState(null);
	const [formData, setFormData] = useState({
		title: "",
		path: "",
		text: "",
	});

	// 🔹 Prefill in edit mode
	useEffect(() => {
		if (editCategory) {
			setFormData({
				title: editCategory.title,
				path: editCategory.path,
				text: editCategory.text || "",
			});
			setImage(null);
		} else {
			setFormData({ title: "", path: "", text: "" });
			setImage(null);
		}
	}, [editCategory]);

	const handleChange = (e) => {
		setFormData({ ...formData, [e.target.name]: e.target.value });
	};

	// 🔹 ADD
	const handleAddCategory = async () => {
		if (!formData.title || !formData.path || !image) {
			toast.error("Title, Path and Image are required");
			return;
		}

		try {
			setLoader(true);
			const id = Date.now().toString();

			const imageRef = sRef(
				storage,
				`categoryImages/${id}_${image.name}`
			);
			await uploadBytes(imageRef, image);
			const imageUrl = await getDownloadURL(imageRef);

			await set(ref(db, `categories/${formData.path}`), {
				id,
				title: formData.title,
				path: formData.path,
				text: formData.text || "",
				img: imageUrl,
				createdAt: Date.now(),
			});

			toast.success("Category added successfully");
			onClose();
		} catch (err) {
			console.error(err);
			toast.error("Failed to add category");
		} finally {
			setLoader(false);
		}
	};

	// 🔹 UPDATE
	const handleUpdateCategory = async () => {
		try {
			setLoader(true);
			let imageUrl = editCategory.img;

			if (image) {
				// delete old image
				if (editCategory.img) {
					await deleteObject(sRef(storage, editCategory.img));
				}

				const imageRef = sRef(
					storage,
					`categoryImages/${editCategory.id}_${image.name}`
				);
				await uploadBytes(imageRef, image);
				imageUrl = await getDownloadURL(imageRef);
			}

			await set(ref(db, `categories/${formData.path}`), {
				...editCategory,
				title: formData.title,
				text: formData.text,
				img: imageUrl,
				updatedAt: Date.now(),
			});

			toast.success("Category updated successfully");
			onClose();
		} catch (err) {
			console.error(err);
			toast.error("Failed to update category");
		} finally {
			setLoader(false);
		}
	};

	return (
		<ContactUsModalView isOpen={isOpen} onClose={onClose}>
			<h3 className="mb-3 text-center">
				{editCategory ? "Edit Category" : "Add Category"}
			</h3>

			<input
				type="text"
				name="title"
				placeholder="Category Name"
				className="modal-input"
				value={formData.title}
				onChange={handleChange}
			/>

			<input
				type="text"
				name="path"
				placeholder="Path should be single name (ex. category) it cannot be changed"
				className="modal-input"
				value={formData.path}
				onChange={handleChange}
				disabled={!!editCategory}
			/>

			<input
				type="text"
				name="text"
				placeholder="Text (optional)"
				className="modal-input"
				value={formData.text}
				onChange={handleChange}
			/>

			<input
				type="file"
				accept="image/*"
				className="modal-input"
				onChange={(e) => setImage(e.target.files[0])}
			/>

			<button
				className="add-category-card-btn mt-3 w-100"
				onClick={
					editCategory ? handleUpdateCategory : handleAddCategory
				}
				disabled={loader}
			>
				{loader
					? "Saving..."
					: editCategory
					? "Update Category"
					: "Add Category"}
			</button>
		</ContactUsModalView>
	);
};

export default AddCategoryModal;
